<template>
  <b-modal id="modal-pdf" centered :hide-header="true" :hide-footer="true">
    <div class="modal-inner">
      <div class="modal-panel-group clearfix">
        <div class="modal-inner">
          <p class="modal-ttl" style="fontSize: 24px">{{ $t('pdf_export') }}</p>
          <form action="" method="">
            <div class="modal-ttl">
              <p>{{ $t('do_you_want_to_export_to_pdf') }}</p>
            </div>
            <div class="modal-btn-area clearfix mt40">
              <div class="btn-base pos-left">
                <a href="javascript:" class="modal-close" @click="exportPDF()">
                  <p>{{ $t('ok') }}</p>
                </a>
              </div>
              <div class="btn-cancel pos-right">
                <a href="javascript:" class="modal-close" @click="$bvModal.hide('modal-pdf')">
                  <p>{{ $t('cancel') }}</p>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { BModal, VBModal, BButton } from 'bootstrap-vue'

export default {
    components: { BModal, BButton },
    directives: { BModal, VBModal, BButton },
    props: {
      activePage: {
        type: String,
        required: true,
      },
    },
    methods: {
      exportPDF() {
        switch (this.activePage) {
          case 'graph':
            this.$emit('setExportChartPDF', true)
            break;
          case 'basic-information':
            this.$emit('setExportAllergyPDF', true)
            break;
          case 'vaccination':
            this.$emit('setExportVaccinPDF', true)
            break;
          case 'home-care-note-book':
            this.$emit('setExportHomecarePDF', true)
            break;
          default:
            break;
        }
      }
    }
}
</script>
